import React from "react";
import Facebook from "../icons/icon-social-facebook.svg";
import Instagram from "../icons/icon-social-instagram.svg";
import Twitter from "../icons/icon-social-twitter.svg";
import LinkedIn from "../icons/icon-social-linkedin.svg";
import Vk from "../icons/icon-social-vk.svg";
import Ok from "../icons/icon-social-ok.svg";
import Youtube from "../icons/icon-social-youtube.svg";
import Visa from "../icons/cc-visa-brands.svg";
import Mastercard from "../icons/cc-mastercard-brands.svg";
import Paypal from "../icons/cc-paypal-brands.svg";
import Amex from "../icons/cc-amex-brands.svg";
import AmazonPay from "../icons/cc-amazonpay-brands.svg";
import Klarna from "../icons/cc-klarna-brands.svg";
import ApplePay from "../icons/cc-applepay-brands.svg";

const FooterIcon = ({ item, className, ...props }) => {
  const resultIcon = (
    <>
      {
        {
          Visa: (
            <Visa
              className={`footer__payment-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          AmazonPay: (
            <AmazonPay
              className={`footer__payment-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          Klarna: (
            <Klarna
              className={`footer__payment-icon${
                className ? ` ${className}` : ""
              } footer__payment-icon--klarna`}
              {...props}
            />
          ),
          ApplePay: (
            <ApplePay
              className={`footer__payment-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          MasterCard: (
            <Mastercard
              className={`footer__payment-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          PayPal: (
            <Paypal
              className={`footer__payment-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          AmericanExpress: (
            <Amex
              className={`footer__payment-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          Facebook: (
            <Facebook
              className={`footer__social-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          Instagram: (
            <Instagram
              className={`footer__social-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          Twitter: (
            <Twitter
              className={`footer__social-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          Youtube: (
            <Youtube
              className={`footer__social-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          Linkedin: (
            <LinkedIn
              className={`footer__social-icon${className ? ` ${className}` : ""}`}
              {...props}
            />
          ),
          VK: (
            <Vk className={`footer__social-icon${className ? ` ${className}` : ""}`} {...props} />
          ),
          Odnoklassniki: (
            <Ok className={`footer__social-icon${className ? ` ${className}` : ""}`} {...props} />
          ),
        }[item.icon?.[0]]
      }
    </>
  );

  return item.externalLink ? (
    <a
      href={item.externalLink}
      target={item.target ? item.target : "self"}
      rel={item.target && item.target === "_blank" ? "noopener noreferrer" : ""}
      className="footer__link"
      aria-label={item.title}
    >
      {resultIcon}
    </a>
  ) : (
    <>{resultIcon}</>
  );
};

export default FooterIcon;
